module.exports = __webpack_public_path__ + "img/logo-momo.e4cffa18.png";